import { Divider, ListItem, ListItemText, Stack } from "@mui/material";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { SiteLink } from "interfaces";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { CookieButton } from "../styled";
import { useLinks } from "hooks/useLinks";

const PrivacyLink = ({
	link,
	children
}: {
	link: SiteLink;
	children: ReactNode;
}) => {
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	return (
		<ListItem
			button
			component="a"
			key={link.analytics_key}
			href={link.path ? link.path : "#"}
			title={link.title}
			target={link?.target ? link.target : "_blank"}
			rel="noreferrer"
			onClick={() => {
				reportEvent(link.analytics_key, {
					source: link.analytics_source
				});
				reportPlaygamiEvent("tp.web_frontend", {
					event_name: link.analytics_key,
					event_type: link.analytics_source,
					action: link.analytics_key,
					source: link.analytics_source
				});
			}}
			sx={{ justifyContent: "center", textAlign: "center" }}
		>
			{children}
		</ListItem>
	);
};
const PrivacyRouterLink = ({
	link,
	children
}: {
	link: SiteLink;
	children: ReactNode;
}) => {
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	return (
		<ListItem
			button
			component={Link}
			to={link.path}
			title={link.title}
			target={link?.target ? link.target : "_blank"}
			rel="noreferrer"
			onClick={() => {
				reportEvent(link.analytics_key, {
					source: link.analytics_source
				});
				reportPlaygamiEvent("tp.web_frontend", {
					event_name: link.analytics_key,
					event_type: link.analytics_source,
					action: link.analytics_key,
					source: link.analytics_source
				});
			}}
			sx={{ justifyContent: "center", textAlign: "center" }}
		>
			{children}
		</ListItem>
	);
};
const CookiesButton = () => {
	const text = "Cookies";

	return (
		//<!-- Usercentrics Cookies Settings button start -->
		<ListItem
			button
			component={CookieButton}
			onClick={() => {
				window.UC_UI?.showSecondLayer();
			}}
			id="uc-sdk-btn"
			className="uc-sdk-show-settings"
			sx={{ justifyContent: "center", textAlign: "center" }}
		>
			<ListItemText
				primary={text}
				sx={{ span: { fontSize: ".8rem", lineHeight: "1.2" } }}
			/>
		</ListItem>
		//<!-- Usercentrics Cookies Settings button end -->
	);
};
export const FooterPrivacyMenu = () => {
	const links = useLinks();

	const privacyLinksData = [
		{
			...links.tos,
			analytics_source: "footer"
		},
		{
			...links.privacy,
			analytics_source: "footer"
		}
	];

	return (
		<>
			<Stack
				direction="row"
				divider={
					<Divider orientation="vertical" flexItem sx={{ height: "20px" }} />
				}
				spacing={2}
				sx={{
					width: "auto",
					alignItems: "center",
					display: "flex",
					a: {
						color: "white",
						textDecoration: "none",
						display: "flex",
						alignItems: "center",
						whiteSpace: "nowrap",
						marginLeft: "0 !important"
					},
					".MuiDivider-root": {
						alignSelf: "auto",
						borderColor: "white",
						margin: 0
					}
				}}
			>
				{privacyLinksData.map((link: SiteLink) => {
					const listContent = (
						<ListItemText
							primary={link.title}
							sx={{ span: { fontSize: ".8rem" } }}
						/>
					);
					return link.path.indexOf("/") === 0 ? (
						<PrivacyRouterLink link={link} key={link.title}>
							{listContent}
						</PrivacyRouterLink>
					) : (
						<PrivacyLink link={link} key={link.title}>
							{listContent}
						</PrivacyLink>
					);
				})}
				<CookiesButton />
			</Stack>
		</>
	);
};
